import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.infos.length > 0 ? _c("div", {
    staticClass: "topic-container"
  }, [_c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Back.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.share
    }
  })]), _c("div", {
    staticClass: "img-con-top"
  }, [_c("img", {
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/P13.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "text-con"
  }, [_c("h4", [_vm._v("# " + _vm._s(_vm.infos[0].content))])])]), _c("div", {
    staticClass: "content"
  }, [_c("van-tabs", {
    ref: "tabs",
    attrs: {
      background: "transparent",
      "title-active-color": "rgba(255,255,255)",
      "title-inactive-color": "rgba(255,255,255,0.60)",
      swipeable: ""
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, _vm._l(_vm.arr, function (item) {
    return _c("van-tab", {
      key: item,
      attrs: {
        title: item,
        name: item
      }
    }, [_c("div", {
      staticClass: "club"
    }, _vm._l(_vm.infos[0].threads, function (item, index) {
      return _c("div", {
        key: index,
        staticClass: "club-item",
        on: {
          click: function click($event) {
            return _vm.toDetail(item.threadId);
          }
        }
      }, [_c("div", {
        staticClass: "user"
      }, [_c("div", {
        staticClass: "user-info",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toMe(item.user.userId);
          }
        }
      }, [item.user.avatar ? _c("img", {
        staticClass: "img",
        attrs: {
          src: item.user.avatar,
          alt: ""
        }
      }) : _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/icon_avatar.png"),
          alt: ""
        }
      }), _c("div", {
        staticClass: "txt"
      }, [_c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
        staticClass: "date"
      }, [_vm._v(_vm._s(item.createdAt))])])]), _vm.userId != item.user.userId ? _c("div", [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.user.followStatus == 2,
          expression: "item.user.followStatus == 2"
        }],
        staticClass: "follow",
        on: {
          click: function click($event) {
            return _vm.toFollow(item.user.userId, item);
          }
        }
      }, [_vm._v(" " + _vm._s(_vm.$t("Follow")))]), _c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.user.followStatus == 1,
          expression: "item.user.followStatus == 1"
        }],
        staticClass: "unFollow",
        on: {
          click: function click($event) {
            return _vm.toUnfollow(item.user.userId, item);
          }
        }
      }, [_vm._v(" Friends")]), _c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.user.followStatus == 0,
          expression: "item.user.followStatus == 0"
        }],
        staticClass: "unFollow",
        on: {
          click: function click($event) {
            return _vm.toUnfollow(item.user.userId, item);
          }
        }
      }, [_vm._v(" Unfollow")])]) : _vm._e()]), _c("div", [_c("div", {
        staticClass: "explain",
        domProps: {
          textContent: _vm._s(item.content.text)
        }
      }), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
        staticClass: "img-con"
      }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
        return _c("div", {
          key: itm.thumbUrl,
          staticClass: "imgBg",
          style: "background:url(" + itm.thumbUrl + ") no-repeat center;background-size:cover;"
        });
      }), 0) : _vm._e()]), _c("div", {
        staticClass: "user-operate"
      }, [_c("div", {
        staticClass: "item-con"
      }, [_c("div", {
        staticClass: "item"
      }, [_c("img", {
        attrs: {
          src: require("../../assets/images/Comments.png"),
          alt: ""
        }
      }), _c("span", [_vm._v(_vm._s(item.likeReward.postCount))])]), _c("div", {
        staticClass: "item",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.thumbsUp(item);
          }
        }
      }, [!item.isLike ? _c("img", {
        attrs: {
          src: require("../../assets/images/Like.png"),
          alt: ""
        }
      }) : _c("img", {
        attrs: {
          src: require("../../assets/images/Like1.png"),
          alt: ""
        }
      }), _c("span", [_vm._v(_vm._s(item.likeReward.likePayCount))])]), _c("div", {
        staticClass: "item",
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toCollect(item);
          }
        }
      }, [!item.isFavorite ? _c("img", {
        attrs: {
          src: require("../../assets/images/Collection.png"),
          alt: ""
        }
      }) : _c("img", {
        attrs: {
          src: require("../../assets/images/Collection1.png"),
          alt: ""
        }
      }), _c("span", [_vm._v(_vm._s(item.likeReward.favoriteCount))])])]), _c("img", {
        attrs: {
          src: require("../../assets/images/Share.png"),
          alt: ""
        }
      })])]);
    }), 0)]);
  }), 1)], 1)]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };